export default __webpack_public_path__ + "static/media/turkgo-logo.b143c121.png";